var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95 8.65C10.3 8.65 11.35 7.55 11.35 6.2C11.35 4.85 10.25 3.8 8.9 3.8C7.55 3.8 6.5 4.9 6.5 6.2C6.5 7.55 7.6 8.65 8.95 8.65ZM8.9 4.8C8.95 4.8 8.95 4.8 8.9 4.8C9.7 4.8 10.35 5.45 10.35 6.25C10.35 7.05 9.7 7.65 8.9 7.65C8.1 7.65 7.5 7 7.5 6.25C7.5 5.45 8.15 4.8 8.9 4.8Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.35 8.35C15.4 7.5 14.15 7.05 12.85 7.1H12.45C12.35 7.5 12.2 7.85 12 8.15C12.3 8.1 12.55 8.1 12.85 8.1C13.8 8.05 14.75 8.35 15.5 8.9V12.5H16.5V8.5L16.35 8.35Z",
    className: "svgFill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 3.9C11.95 3.3 12.65 3 13.3 3.25C13.9 3.5 14.2 4.2 13.95 4.85C13.75 5.3 13.3 5.6 12.85 5.6C12.75 5.6 12.6 5.6 12.5 5.55C12.55 5.8 12.55 6.05 12.55 6.25V6.55C12.65 6.55 12.75 6.6 12.85 6.6C14.1 6.6 15.1 5.6 15.1 4.4C15.1 3.15 14.1 2.15 12.9 2.15C12.1 2.15 11.4 2.55 11 3.25C11.25 3.4 11.5 3.6 11.7 3.9Z",
    className: "svgFill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.2C5.8 7.9 5.65 7.55 5.55 7.15H5.15C3.85 7.1 2.6 7.55 1.65 8.35L1.5 8.5V12.5H2.5V8.9C3.3 8.35 4.2 8.05 5.15 8.1C5.45 8.1 5.75 8.15 6 8.2Z",
    className: "svgFill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15001 6.55C5.25001 6.55 5.35001 6.55 5.45001 6.5V6.2C5.45001 5.95 5.45001 5.7 5.50001 5.5C5.40001 5.55 5.25001 5.55 5.15001 5.55C4.50001 5.55 3.95001 5 3.95001 4.35C3.95001 3.7 4.50001 3.15 5.15001 3.15C5.65001 3.15 6.10001 3.45 6.30001 3.9C6.50001 3.65 6.80001 3.4 7.05001 3.2C6.40001 2.15 5.05001 1.8 4.00001 2.45C2.95001 3.1 2.60001 4.45 3.25001 5.5C3.65001 6.15 4.35001 6.55 5.15001 6.55Z",
    className: "svgFill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.05 11.35L12.95 11.2C11.95 10.1 10.55 9.45 9.05 9.5C7.55 9.45 6.1 10.1 5.1 11.2L5 11.35V15.15C5 15.6 5.35 16 5.85 16H12.25C12.7 16 13.1 15.6 13.1 15.15V11.35H13.05ZM12.05 15H6V11.7C6.8 10.9 7.9 10.5 9.05 10.5C10.15 10.45 11.25 10.9 12.05 11.7V15Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.62a212b5.svg";
export { ForwardRef as ReactComponent };